import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['row', 'viewButton']
  static values = { baseUrl: String }

  connect() {
    this.selectedId = null
  }

  select(event) {
    const row = event.currentTarget

    // Don't allow selection of hidden rows
    if (row.classList.contains('hidden')) {
      return
    }

    const assessmentId = row.dataset.assessmentId

    // Deselect all rows
    this.rowTargets.forEach((r) => {
      r.classList.remove('bg-indigo-50', 'ring-2', 'ring-indigo-500')
    })

    // Select clicked row
    row.classList.add('bg-indigo-50', 'ring-2', 'ring-indigo-500')
    this.selectedId = assessmentId

    // Enable and update the view button
    const viewButton = this.viewButtonTarget
    viewButton.classList.remove(
      'bg-gray-300',
      'cursor-not-allowed',
      'pointer-events-none'
    )
    viewButton.classList.add('bg-indigo-600', 'hover:bg-indigo-500')
    viewButton.href = `${this.baseUrlValue}/${assessmentId}`
  }
}
